import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { SaveButton, CancelButton } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';

const REPORT_TYPES = ['bug', 'improvement'];

const ReportIssuesForm = ({ onSubmit, onCancel, loading }) => {
  const MAX_FILES = 5;
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    title: '', description: '', report_type: 'bug'
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [saving, setSaving] = useState(false);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };



  const canSave = formData.title.trim() !== '' && formData.description.trim() !== '';

  const handleSubmit = async () => {
    setSaving(true);

    const payload = new FormData();
    payload.append('report[title]', formData.title);
    payload.append('report[description]', formData.description);
    payload.append('report[report_type]', formData.report_type);
    selectedFiles.forEach(file => payload.append('report[images][]', file));

    await onSubmit(payload);
    setSaving(false);
  };

  return (
    <Form className="mb-4 p-3 border rounded">
      <Row className="mb-3">
        <Col md={12}>
          <Form.Group>
            <Form.Label>{t('title')}</Form.Label>
            <Form.Control
              data-testid="title_input"
              value={formData.title}
              onChange={(e) => handleChange('title', e.target.value)}
              placeholder={t('title')}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
          <Form.Group>
            <Form.Label>{t('report_type')}</Form.Label>
            <Form.Select data-testid="report_type_select" value={formData.report_type} onChange={(e) => handleChange('report_type', e.target.value)}>
              {REPORT_TYPES.map(type => <option key={type} value={type}>{t(type)}</option>)}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
          <Form.Group>
            <Form.Label>{t('description')}</Form.Label>
            <Form.Control
              data-testid="description_input"
              as="textarea"
              rows={6}
              style={{ height: 'auto' }}
              value={formData.description}
              onChange={(e) => handleChange('description', e.target.value)}
              placeholder={t('description')}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
          <Form.Group>
            <Form.Label>{t('screenshots')}</Form.Label>
            <Form.Control
              data-testid="screenshot_input"
              type="file"
              accept="image/*"
              onChange={(e) => setSelectedFiles(e.target.files[0] ? [e.target.files[0]] : [])}
            />
            {selectedFiles.length > 0 && (
              <Form.Text className="text-muted">
                {selectedFiles.map(f => f.name).join(', ')}
              </Form.Text>
            )}
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2">
        <CancelButton data-testid="cancel_button" onClick={onCancel} disabled={saving} />
        <SaveButton
          data-testid="save_button"
          onClick={handleSubmit}
          disabled={saving || !canSave || loading}
          text={saving ? t('saving') : t('submit_report')}
        />
      </div>
    </Form>
  );
};

export default ReportIssuesForm;
